import { render } from "./exchange_rate_card.html?vue&type=template&id=28f81bbb&external"
import script from "./exchange_rate_card.js?vue&type=script&lang=js&external"
export * from "./exchange_rate_card.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__